import { ROLES } from "utils/helpers/enums/roles.enum";
import { BAGDE_TYPES, INDUSTRY_TYPES } from "utils/helpers/enums/shared.enum";
import { format } from "date-fns";
import { PictureDTO } from "../shared/picture.dto";

export class BadgeDTO {
    badgeType: BAGDE_TYPES;
    criteria: Criteria = new Criteria();
    imageId: number;
    imageUrl: string;
    industry: INDUSTRY_TYPES;
    image: PictureDTO = new PictureDTO();
    createdAt: string;
    id: number;
  
    constructor(data: Partial<BadgeDTO> = {}) {
        for(let key in data){
            if(key === 'criteria'){
                this[key] = new Criteria(data[key] ?? {});
            }else if(key === 'image'){
                this[key] = new PictureDTO(data[key] ?? {});
            }else if(key === 'createdAt'){
                this[key] = format(new Date(data[key]), "MMMM dd, yyyy, hh:mm a")
            } else{
                this[key] = data[key];
            }
        }
    }
  }

  export class Criteria {
    registrationDuration: string = '';
    eventCount: number = 0;
    forRole: ROLES;
  
    constructor(data: Partial<Criteria> = {}) {
        Object.assign(this,data);
    }
  }